// Regex to loosely match phone numbers
export const phoneNumberValidationPattern = new RegExp(/^\s*([0-9().+-]\s*){8,18}\s*$/)
